
import React, { useState } from 'react';
import { useToast } from '@/hooks/use-toast';
import { calculateContribution } from './utils/calculator';
import { CalculatorForm } from './components/CalculatorForm';
import { CalculatorResultsView } from './components/CalculatorResultsView';
import type { z } from 'zod';
import type { calculatorSchema } from './schema';

type FormValues = z.infer<typeof calculatorSchema>;

export default function FairDealCalculator() {
  const [isCalculating, setIsCalculating] = useState(false);
  const [results, setResults] = useState<any | null>(null);
  const { toast } = useToast();
  
  const handleSubmit = async (data: FormValues) => {
    setIsCalculating(true);
    
    try {
      // Short timeout to simulate calculation
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      const calculationResults = calculateContribution(data);
      setResults(calculationResults);
      
      toast({
        title: "Calculation Complete",
        description: "Your Fair Deal contribution estimate is ready to view.",
      });
    } catch (error) {
      console.error("Error calculating contribution:", error);
      toast({
        title: "Calculation Error",
        description: "There was a problem with your calculation. Please check your inputs and try again.",
        variant: "destructive",
      });
    } finally {
      setIsCalculating(false);
    }
  };

  return results ? (
    <CalculatorResultsView
      results={results}
      formData={results}
      onRecalculate={() => setResults(null)}
    />
  ) : (
    <CalculatorForm
      onSubmit={handleSubmit}
      isCalculating={isCalculating}
    />
  );
}
